import React, { memo } from 'react';
import { Square as StopIcon } from 'lucide-react';

/**
 * Send/Stop button component
 * Shows stop button during generation, send button otherwise
 */
const SendButton = memo(({
  agentStatus,
  handleStopGeneration,
  isEventConnected,
  isSandboxReady,
  readOnly = false,
  hasOversizedFiles = false,
}) => {
  const isGenerating = agentStatus === 'generating';
  const isDisabled = readOnly || !isEventConnected || isGenerating || !isSandboxReady || hasOversizedFiles;

  if (isGenerating && handleStopGeneration) {
    return (
      <button 
        type="button"
        onClick={handleStopGeneration}
        className="bg-semantic-error/20 hover:bg-semantic-error/30 text-semantic-error px-4 py-1.5 ml-1 rounded-lg flex items-center justify-center transition-all shadow-sm text-sm font-medium min-w-0"
        title="Stop agent generation"
      >
        <StopIcon size={14} className="mr-1.5" />
        Stop
      </button>
    );
  }

  // Determine button title based on disabled reason
  const getButtonTitle = () => {
    if (hasOversizedFiles) return 'Remove oversized files before sending';
    if (!isEventConnected) return 'Connecting...';
    if (!isSandboxReady) return 'Sandbox not ready';
    return 'Send message';
  };

  return (
    <button
      type="submit"
      className={`${
        isEventConnected && !isGenerating && isSandboxReady && !readOnly && !hasOversizedFiles
          ? 'bg-brand-action hover:bg-brand-action-hover text-brand-action-text shadow-sm'
          : 'bg-neutral-200 dark:bg-neutral-700 text-neutral-400 cursor-not-allowed'
      } p-2 ml-1 rounded-xl flex items-center justify-center transition-all min-w-0`}
      disabled={isDisabled}
      title={getButtonTitle()}
      data-tour="send-button"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
      </svg>
    </button>
  );
});

SendButton.displayName = 'SendButton';

export default SendButton;